import { en } from './translations/_en';
import { tr } from './translations/_tr';
import { aa } from './translations/_aa';

// Immutable copies used to seed missing DB keys (dev / doruk.tech).
// Runtime `i18n` may be overwritten by /api/global/translations.
export const bundledI18n = {
    en,
    tr,
    aa,
};

const languages = {
    // Start from bundled fallbacks; bootstrap merges DB on top.
    i18n: {
        en: en,
        tr: tr,
        aa: aa,
    },
    bundledI18n,
    // Metadata (nativeName, sortOrder) populated from
    // /api/global/config languageList. Keyed by language code.
    meta: {},
    date: {
        en: 'en',
        tr: 'tr',
        aa: 'ar',
        pt: 'pt',
        es: 'es',
        fr: 'fr',
        ko: 'ko',
        ja: 'ja',
    },
    languageCodes: {
        en: 'en',
        tr: 'tr',
        aa: 'iq',
        pt: 'pt',
        es: 'es',
        fr: 'fr',
        ko: 'kr',
        ja: 'jp',
    },
};

export default languages;
